import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { CuestionarioService } from "../_services/cuestionario.service";

import { NormasService } from '../_services/normas.service';

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery:any;

@Component({
  selector: 'cuestionarios',
  templateUrl: 'cuestionarios.template.html'
})
export class CuestionariosComponent  implements OnInit, OnDestroy {

  subscription: Subscription;

  listabloques: any=[];
  detallebloque: boolean = true;
  bloqueseleccionado: number = 0;

  listaareas: any=[];
  detallearea: boolean = true;
  areaseleccionada: number = 0;

  listamodulos: any=[];
  detallemodulo: boolean = true;
  moduloseleccionado: number = 0;

  listacuestionarios: any = [];
  detallecuestionario: boolean = true;
  listaCuestionarioTipos: any = [];

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  filterQuery: string = "";
  filteredByTipoCuestionario:any = [];
  mostrarFiltros: boolean = false;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private cuestionarioService: CuestionarioService,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private confirmationService: ConfirmationService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.globalEventsManager.menuExtendido(true);
    let breadcrumb: any = [
      {
        'path':'#',
        'name': 'Cuestionarios'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    //this.getListaModulos(0);
    //
    this.getListaBloques();
    this.getCuestionarioTipos();

    let _id_modulo = this.activatedRoute.snapshot.params["id_modulo"];
    if (_id_modulo){
      this.moduloseleccionado = _id_modulo;
      this.verModulo(this.moduloseleccionado);
    }

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }


  stripText(val: string){
    var cadena: string = "";

    if (val != null){
      if (val.length>25){
        cadena = val.substr(0, 25)+"...";
      }else{
        cadena = val;
      }
    }

    return cadena;
  }


  scrollLienzo(){

    jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
  }

  getListaBloques(){
    this.normasService.getListaBloques(1).subscribe(
      data => {
        if (data){
          this.listabloques = data.json().lista;
          console.log(this.listabloques);
        }
      }
    );
  }

  verBloque(id_bloque:number){
    //this.router.navigate(['cuestionarios',id_modulo]);
    this.detallebloque = false;
    this.bloqueseleccionado = id_bloque;
    this.getListaAreas(this.bloqueseleccionado);
    this.resetArea();

    this.scrollLienzo();
  }

  getListaAreas(id_bloque: number){
    this.normasService.getListaAreas(id_bloque,1).subscribe(
      data => {
        if (data){
          this.listaareas = data.json().lista;
          console.log(this.listaareas);
        }
      }
    );
  }

  resetArea(){
    this.detallearea = true;
    this.areaseleccionada = 0;
    this.resetModulo();
  }

  verArea(id_area:number){
    this.detallearea = false;
    this.areaseleccionada = id_area;
    this.getListaModulos(this.areaseleccionada);
    this.resetModulo();
    this.scrollLienzo();
  }

  getListaModulos(id_area:number){
    this.normasService.getListaModulos(id_area,1).subscribe(
      data => {
        if (data){
          this.listamodulos = data.json().lista;
          console.log(this.listamodulos);
        }
      }
    );
  }

  resetModulo(){
    this.detallemodulo = true;
    this.moduloseleccionado = 0;
  }

  verModulo(id_modulo:number){
    //this.router.navigate(['cuestionarios',id_modulo]);
    this.detallemodulo = false;
    this.moduloseleccionado = id_modulo;
    this.getListaCuestionarios(this.moduloseleccionado);

    this.scrollLienzo();
  }

  getListaCuestionarios(id_modulo:number){

    console.log("getCuestionarios");

    this.cuestionarioService.getListaCuestionarios(id_modulo).subscribe(
      data => {
        if (data){
          console.log(data.json());
          this.listacuestionarios = data.json().lista;
        }
      }
    );
  }

  verCuestionario(id_cuestionario: number){
    this.router.navigate(['cuestionario',id_cuestionario]);
  }

  nuevoCuestionario(id_modulo:number){
  
    this.cuestionarioService.nuevoCuestionario(id_modulo).subscribe(
      data => {
        if (data){
          this.listacuestionarios = data.json().lista;
          console.log(this.listacuestionarios);
        }
      }
    );
  }

  borrarCuestionario(id_cuestionario:number){
    this.cuestionarioService.borrarCuestionario(id_cuestionario).subscribe(
      data => {
        if (data){
          this.getListaCuestionarios(this.moduloseleccionado);
        }
      }
    );
  }

  duplicarCuestionario(id_cuestionario: number){
    this.cuestionarioService.duplicarCuestionario(id_cuestionario).subscribe(
      data => {
        if (data){
          this.getListaCuestionarios(this.moduloseleccionado);
        }
      }
    );
  }

  cerrar(nivel:number){

    //le pasamos el nivel al que tiene que ir

    if (nivel <= 1){
      this.moduloseleccionado = 0;
      this.detallemodulo = true;
    }

  }

  expandir(nivel:number){
    if (nivel == 1){
      (this.detallebloque) ? this.detallebloque = false : this.detallebloque = true;
    }
    if (nivel == 2){
      (this.detallearea) ? this.detallearea = false : this.detallearea = true;
    }
    if (nivel == 3){
      (this.detallemodulo) ? this.detallemodulo = false : this.detallemodulo = true;
    }
  }

  confirm(id_cuestionario: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar el cuestionario?',
          accept: () => {
              this.borrarCuestionario(id_cuestionario);
          }
      });
  }

  getCuestionarioTipos(){

    this.cuestionarioService.getCuestionarioTipos().subscribe(
      data => {
        
        this.listaCuestionarioTipos= data.json().cuestionario;
       
      }
    )}


  filtrarLista(value){

    this.cuestionarioService.getListaCuestionarios(this.moduloseleccionado).subscribe(
      data => {
        if (data){

          this.listacuestionarios = data.json().lista;
          if (value != 0){
            this.filteredByTipoCuestionario =  this.listacuestionarios.filter(
              item => item.id_cuestionario_tipo.indexOf(value.toLowerCase()) > -1
            )
            this.listacuestionarios = this.filteredByTipoCuestionario;
          }else{
            this.getListaCuestionarios(this.moduloseleccionado);
          }
        }
    })
    
  }



}



// WEBPACK FOOTER //
// ./src/app/cuestionario/cuestionarios.component.ts